import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ResponsiveDialog(props) {
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    if (props.open !== undefined && props.open !== open) {
        setOpen(props.open)
    }
  }, [open, props])

  return (
      <Dialog
        open={open}
        onClose={() => props.onClose()}
        aria-labelledby="responsive-dialog-title">
          {
            props.walletModal || props.offerDetailsModal ? '' : <DialogTitle id="responsive-dialog-title">{"Terms & Conditions"}</DialogTitle>
          }
        <DialogContent>
            {props.children}
        </DialogContent>
        {
          !props.offerDetailsModal ?
          <DialogActions>
            <Button onClick={() => props.onClose()} color="primary" autoFocus>
              close
            </Button>
          </DialogActions> : ''
        }
      </Dialog>
  );
}